import Router from "@/helpers/router";

export const ROUTES_EXPECTED_IGNORE_AUTH_LOGS = [
  Router.verify(),
  Router.signup(),
];
